
const AccessDenied = ({text = "No contact information found !"}) => {
    return (
        <div className={`dmpc__steper__content dmpc__process__block`}>
            {text}
        </div>
    );
}
export default AccessDenied;